<nav class="filters-nav-menu">
    <div class="filters-nav" >
        <div class="op_icon" (click)="onSelect('');open=!open; " title="Open filters">
            <span ></span>
        </div>
        <ul [hidden]="!open || selectedFilter!='' ">
          <li *ngFor="let filter of filters | sortByMenuOrder" (click)="onSelect(filter.key)">
              <span class="filter-title" >{{filter.title}}</span>
          </li>
        </ul>
    </div>
  </nav>
